import { render } from "./SectionHeading.vue?vue&type=template&id=8ba38632&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"

import "./SectionHeading.vue?vue&type=style&index=0&id=8ba38632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba38632"]])

export default __exports__